import MaintenancePage from "../../components/feature/MaintenancePage";
import SEOHead from "../../components/feature/SEOHead";

const LOGO =
  "https://storage.readdy-site.link/project_files/9ee712e0-c50a-4d2b-9956-d4b4346de3f4/d2fada1a-83f7-4962-8c43-3eeb73ac8cd1_Sboomerang_Logo.png?v=3d767f61f910439fbfe8efa8bc26645a";

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "https://example.com";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/sboomerang#website`,
  name: "Sboomerang",
  url: `${siteUrl}/sboomerang`,
  inLanguage: "en-AU",
  description:
    "Sboomerang is currently undergoing scheduled maintenance. We'll be back soon with an improved online gaming experience for all users.",
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/sboomerang?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function Sboomerang() {
  return (
    <>
      <SEOHead
        title="Sboomerang | We'll Be Back Shortly — Maintenance Mode"
        description="Sboomerang is currently undergoing scheduled maintenance. We'll be back soon with an improved experience for all users."
        keywords="Sboomerang, online gaming, maintenance, coming soon"
        canonicalPath="/sboomerang"
        schemaJson={schema}
        ogImage={LOGO}
        ogImageAlt="Sboomerang Logo"
        siteName="Sboomerang"
      />
      <MaintenancePage
        logoSrc={LOGO}
        logoAlt="Sboomerang Logo"
        accentColor="#FFD600"
        glowRgb="255,214,0"
        bgFrom="#1A1500"
        whatsappLink="https://wa.me/61404648836"
        telegramLink="https://t.me/Sboomerangaus"
      />
    </>
  );
}
